/* ==========================================================================
   go-stats-results.js
   Anima los anillos de progreso (stroke-dashoffset) y cuenta el porcentaje
   0 -> valor cuando la tarjeta entra en viewport. IntersectionObserver.
   Idempotente y compatible con el editor de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var CIRCUMFERENCE = 2 * Math.PI * 36; // r = 36 -> ≈ 226.19

  function animateRing(ring) {
    if (ring.dataset.statDone === '1') return;
    ring.dataset.statDone = '1';

    var pct = parseFloat(ring.dataset.percent) || 0;
    pct = Math.max(0, Math.min(100, pct));

    var bar = ring.querySelector('[data-go-stat-bar]');
    var valueEl = ring.querySelector('[data-go-stat-value]');

    // Anillo: la transición CSS hace el llenado
    if (bar) {
      var offset = CIRCUMFERENCE * (1 - pct / 100);
      // forzar reflow para asegurar la transición desde el estado inicial
      void bar.getBoundingClientRect();
      bar.style.strokeDashoffset = String(offset);
    }

    // Conteo numérico
    if (valueEl) {
      var duration = 1200;
      var start = null;
      function tick(ts) {
        if (start === null) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
        valueEl.textContent = Math.round(eased * pct) + '%';
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
  }

  function initSection(section) {
    if (section.dataset.statInit === '1') return;
    section.dataset.statInit = '1';

    var rings = Array.prototype.slice.call(section.querySelectorAll('[data-go-stat-ring]'));
    if (!rings.length) return;

    if (!('IntersectionObserver' in window)) {
      rings.forEach(animateRing);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateRing(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    rings.forEach(function (ring) { observer.observe(ring); });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-go-stats]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
